import React, { useEffect, useReducer, useState } from "react";
import TextInput from "../../components/Common/TextInput";
import CallOut from "../../components/Common/CallOut";
import Notification from "../../components/Common/Notification";
import ActivityLoader from "../../components/Common/ActivityLoader";
import { useSchool } from "../../DataStore/SchoolContext";
import { useTheme } from "../../DataStore/ThemeContext";

const reducer = (state, action) => {
  if (action.type === "RESET") {
    return { ...initialState };
  }
  return { ...state, [action.type]: action.value };
};

const initialState = {
  class: "",
  flag: "old",
  loading: false,
};

const SyncStudents = () => {
  const { getClasses, classListing, syncStudents } = useSchool();
  const {setSystemFunction, closeSettings} = useTheme(); 
  const [info, setInfo] = useState(null);

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (info) {
      setTimeout(() => {
        setInfo(null);
      }, 5000);
    }
  }, [info]);

   useEffect(()=>{
          setSystemFunction(() => async () => {
              await handleConfirm();
          });
          return () => setSystemFunction(null);
      }, [state]);

   

  const handleConfirm = async () => {

    if (!state.class.value) {
      setInfo(
        <Notification
          type="danger"
          message="Select class, then try again"
        />
      );
      return;
    }
    setInfo(
      <Notification
        type="info"
        message="Synchronization in progress. Please wait..."
      />
    );
    await syncStudents(state.class.value, state.flag);
    closeSettings();
  };

  const RenderClass = () => {
    const options = [];
    Array.isArray(classListing) &&
      classListing.map((item) =>
        options.push({ label: item.class_name, value: item.id })
      );

    return (
      <TextInput
        label="Target Class"
        type="select"
        leftIcon="fa fa-user-group"
        placeholder={state.class.label || "Select class...."}
        options={options}
        onChange={(item) => dispatch({ type: "class", value: item })}
        leftComponent={
          <i className="fa fa-user-group link" onClick={getClasses}></i>
        }
        loading={!classListing}
        wrap
        value={state.class}
      />
    );
  };

  return (
    <>
      <CallOut
        title="Students Synchronization"
        description="Add new students or update existing student records directly from your student database server."
      />
      <div className="mt-4">{info}</div>
      
      <form className="form-horizontal" method="post" onSubmit={handleConfirm}>
        {RenderClass()}

        {/** Improved Flag Section */}
        <div className="mt-4">
          <div className="card shadow-sm p-3">
            <h5 className="card-title mb-3 fs-12">Select Student Status</h5>
            <div className="d-flex align-items-center justify-content-between">
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  id="old"
                  name="flag"
                  value="old"
                  className="form-check-input"
                  checked={state.flag === "old"}
                  onChange={(e) =>
                    dispatch({ type: "flag", value: e.target.value })
                  }
                />
                <label
                  htmlFor="old"
                  className="form-check-label ml-2 font-weight-bold"
                >
                  Flag as Continuing
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  id="new"
                  name="flag"
                  value="new"
                  className="form-check-input"
                  checked={state.flag === "new"}
                  onChange={(e) =>
                    dispatch({ type: "flag", value: e.target.value })
                  }
                />
                <label
                  htmlFor="new"
                  className="form-check-label ml-2 font-weight-bold"
                >
                  Flag as New
                </label>
              </div>
            </div>
          </div>
        </div>

      
      </form>
    </>
  );
};

export default SyncStudents;
